<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
    <div mat-dialog-content class="c-modal__dialog">
        <div class="c-modal__header">
            <div class="o-grid">
                <div class="o-grid__cell u-no-p">
                    <p style="font-size: 22px">{{ 'Training.Selection.Description' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                    <button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-modal__content u-no-pt">
            <div class="c-card c-card--height-fit" style="box-shadow:none;">
                <form name="vm.form" class="c-form u-ost-md">
                    <div class="o-grid o-grid--wrap">
                        <div class="o-grid__cell o-grid__cell--w-100 u-no-p">
                            <div class="c-form__group u-osb-lg">
                                <label class="c-form__label c-form__label">{{ 'Training.Selection.Select_Program' | translate }}</label>
                                <mat-select id="trainingPrograms" name="trainingPrograms" *ngIf="vm.trainingPrograms" class="mat-select mat-select--border" [(value)]="vm.selectedTrainingProgram" required>
                                    <mat-option id="trainingProgram{{$index}}" *ngFor="let trainingProgram of vm.trainingPrograms ; let $index=index" [value]="trainingProgram">{{ vm.getTrainingProgramText(trainingProgram) }}</mat-option>
                                    <mat-select-trigger>{{ vm.getTrainingProgramText(vm.selectedTrainingProgram) }}</mat-select-trigger>
                                </mat-select>
                            </div>
                            <div class="c-form__group u-osb-lg"
                                [ngClass]="{ 'c-form__group--error': vm.submitted && !vm.dateRangeModel }">
                                <label for="trainingPeriod" class="c-form__label c-form__label">{{ 'Training.Selection.Select_Period' | translate }} *</label>
                                <div id="trainingPeriod" *ngIf="vm.initialized">
                                    <input-datepicker-new
                                        id="trainingPeriodDatePicker"
                                        name="trainingPeriod"
                                        [(model)]="vm.dateRangeModel"
                                        [minDate]="vm.dateRangeMin"
                                        data-el-parent="datePickerContainer"
                                        [hasTimepicker]="false"
                                        [hasCalendarIcon]="false"
                                        [isSingleDate]="false"
                                        [isRequired]="true">
                                    </input-datepicker-new>
                                </div>
                            </div>
                            <div class="c-form__group u-osb-lg">
                                <label for="groupName" class="c-form__label c-form__label">{{ 'Training.Selection.Group_Label' | translate }}</label>
                                <input
                                        id="groupName"
                                        name="groupNameInput"
                                        type="text"
                                        class="c-form__input c-form__input--sm" spellcheck="false"
                                        [placeholder]="'Training.Selection.Group_Placeholder' | translate"
                                        [(ngModel)]="vm.groupName">
                            </div>
                        </div>
                    </div>
                    <div class="c-panel u-no-p u-ost-sm u-osb-sm">
                        <button
                            type="button"
                            id="trainingLaunchSubmitButton"
                            (click)="vm.submit()"
                            [disabled]="vm.processing || !vm.initialized"
                            class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
                            {{ 'Employees.Confirm' | translate }}
                        </button>
                    </div>
                </form>
                <loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
            </div>
        </div>
    </div>
</div>
